export default __webpack_public_path__ + "static/media/personicon.e5115b17.svg";